@if (!isFinished()) {
  <div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
      <a (click)="back()">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>
      <div class="p-2 flex-grow-1 pl-2">
        <h1 class="text-dark text-center">Detalle del pedido</h1>
      </div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
      <div class="row row-cols-12 mt-0" [ngClass]="isActive()">
        <div class="col-8">
          <div class="text-p p-3 pb-0 nameUser">
            #{{ ordenComercio()?.id }}
          </div>
          <div class="text-p p-3 pt-0 pb-3 dateUser">
            <a [routerLink]="[url_perfil_cliente()]">
              <span style="color:#205EA5">{{ nombre() }}</span>
            </a>
          </div>
        </div>

        <div class="col-4 col-profile">
          <a [routerLink]="[url_perfil_cliente()]">
            <img
              class="text-end rounded-circle business-profile"
              [src]="preview_img_avatar() === '' ? './assets/img/user-init.png' : preview_img_avatar()"
            />
          </a>
        </div>
      </div>

      <hr class="divisor mt-3 mb-1" [ngClass]="isActive()" />

      <div class="text-p p-3 pt-2 pb-2 locationUser d-flex align-items-center" [ngClass]="isActive()">
        @if (b_envio_domicilio()) {
          <span class="pe-3 d-flex align-items-center">
            <i class="bi bi-truck icons-detail pe-1"></i><span>Envío a domicilio</span>
          </span>
        } @else {
          <span class="pe-3 d-flex align-items-center">
            <i class="bi bi-shop icons-detail pe-1"></i><span>Retiro en el local</span>
          </span>
        }

        @if (b_pago_mercadopago()) {
          <span class="pe-1">
            <img src="./assets/img/mercado_pago.png" title="Mercado Pago" class="icon-mercadopago pe-1" />
            <span>MercadoPago</span>
          </span>
        }

        @if (b_pago_efectivo()) {
          <span class="pe-3 d-flex align-items-center">
            <i class="bi bi-cash-coin icons-detail pe-1"></i><span>Pago en Efectivo</span>
          </span>
        }

        @if (x_img_receta()) {
          <span title="Descargar Receta" class="ps-1 pe-0 icon-receta" (click)="openFile()">
            <i class="bi bi-file-earmark-text"></i><span>Receta</span>
          </span>
        }
      </div>

      <hr class="divisor mt-0 mb-1" [ngClass]="isActive()" />

      <!-- ===================== DETALLE PRODUCTOS ===================== -->
      @if (panel() === 'details') {
        <div class="row-cols-12 mt-0" id="product-details">
          @for (vademecum of vademecumsOrdenComercio(); track vademecum.id_vademecum) {
            <div class="row p-3 pb-2">
              <div class="col-8 col-lg-8">
                <div
                  class="text-start title-product"
                  [ngClass]="{
                    'text-decoration-line-through text-danger': !vademecum.b_activo,
                    'text-success': !vademecum.id
                  }"
                >
                  {{ vademecum.n_cantidad }} x {{ vademecum.x_nombre }}
                </div>

                <div
                  class="text-start description-product"
                  [ngClass]="{
                    'text-decoration-line-through text-danger': !vademecum.b_activo,
                    'text-success': !vademecum.id
                  }"
                >
                  {{ vademecum.nombreLaboratorio }} - {{ vademecum.x_presentacion }}
                </div>

                @if (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0) {
                  <div class="d-flex text-start">
                    <div
                      class="col-auto text-title-item rounded-pill bg-primary text-light discount-shop d-flex align-items-center me-1"
                    >
                      {{ vademecum.n_porcentaje_descuento }}% OFF
                    </div>
                  </div>
                }
              </div>

              <div class="col-4 col-lg-4">
                <div class="col-12 col-lg-12 fw-bold text-end">
                  @if (vademecum.b_activo) {
                    <input
                      class="add-number"
                      type="number"
                      [value]="
                        (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0)
                          ? vademecum.n_precio
                          : vademecum.n_precio_final
                      "
                      (keyup)="updateVademecum(vademecum.id_vademecum!, $any($event.target).value)"
                    />
                  } @else {
                    <span class="text-decoration-line-through text-danger">
                      {{ vademecum.n_precio_final | currency:'ARS' }}
                    </span>
                  }
                </div>

                @if (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0) {
                  <div
                    class="col-12 text-end text-title-item pt-1 pb-1"
                    [ngClass]="vademecum.b_activo ? 'text-primary' : 'text-decoration-line-through text-danger'"
                  >
                    <b>{{ (vademecum.n_precio_final! * (1 - vademecum.n_porcentaje_descuento/100)) | currency:'ARS' }}</b>
                  </div>
                }

                @if (vademecum.b_activo) {
                  <div class="d-flex col-12 col-lg-12 fw-bold text-end">
                    <div class="col-auto col-lg-2 add-button detail-icons m-2 p-1">
                        <i class="bi bi-dash align-middle" (click)="deleteVademecum(vademecum.id_vademecum!)" [title]="(vademecum.n_cantidad ?? 1) > 1 
                                                                                                                    ? 'Eliminar 1 unidad'
                                                                                                                    : 'Eliminar producto completo'">
                        </i>
                    </div>
                    <div class="col-auto col-lg-12 add-button detail-icons m-2 p-1">
                      <i class="bi bi-arrow-left-right" (click)="changeVademecum(vademecum.id_vademecum!)" title="Cambiar producto"></i>
                    </div>
                  </div>
                } @else {
                    <div class="col-auto col-lg-12 add-button detail-icons m-2 p-1">
                      <i class="bi bi-arrow-counterclockwise" (click)="restoreVademecum(vademecum.id_vademecum!)" title="Restaurar producto eliminado"></i>
                    </div>
                }
              </div>

              <hr class="divisor mt-4 mb-1" />
            </div>
          }

          @for (producto of productosOrdenComercio(); track producto.id_producto) {
            <div class="row p-3 pb-2">
              <div class="col-8 col-lg-8">
                <div
                  class="text-start title-product"
                  [ngClass]="{
                    'text-decoration-line-through text-danger': !producto.b_activo,
                    'text-success': !producto.id
                  }"
                >
                  {{ producto.n_cantidad }} x {{ producto.x_nombre }}
                </div>

                <div
                  class="d-flex text-start description-product"
                  [ngClass]="{
                    'text-decoration-line-through text-danger': !producto.b_activo,
                    'text-success': !producto.id
                  }"
                >
                  <div class="col-auto">SKU: {{ producto.x_sku }}</div>
                </div>

                @if (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0) {
                  <div class="d-flex text-start">
                    <div
                      class="col-auto text-title-item rounded-pill bg-primary text-light discount-shop d-flex align-items-center me-1"
                    >
                      {{ producto.n_porcentaje_descuento }}% OFF
                    </div>
                  </div>
                }
              </div>

              <div class="col-4 col-lg-4">
                <div class="col-12 col-lg-12 fw-bold text-end">
                  @if (producto.b_activo) {
                    <input
                      class="add-number"
                      type="number"
                      [value]="
                        (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0)
                          ? producto.n_precio
                          : producto.n_precio_final
                      "
                      (keyup)="updateProducto(producto.id_producto!, $any($event.target).value)"
                    />
                  } @else {
                    <span class="text-decoration-line-through text-danger">
                      {{ producto.n_precio_final | currency:'ARS' }}
                    </span>
                  }
                </div>

                @if (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0) {
                  <div
                    class="col-12 text-end text-title-item pt-1 pb-1"
                    [ngClass]="producto.b_activo ? 'text-primary' : 'text-decoration-line-through text-danger'"
                  >
                    <b>{{ (producto.n_precio_final! * (1 - producto.n_porcentaje_descuento/100)) | currency:'ARS' }}</b>
                  </div>
                }

                @if (producto.b_activo) {
                  <div class="d-flex col-12 col-lg-12 fw-bold text-end">
                    <div class="col-auto col-lg-2 add-button detail-icons m-2 p-1">
                        <i class="bi bi-dash align-middle" (click)="deleteProducto(producto.id_producto!)" [title]="(producto.n_cantidad ?? 1) > 1 
                                                                                                            ? 'Eliminar 1 unidad'
                                                                                                            : 'Eliminar producto completo'">
                        </i>
                    </div>
                    <div class="col-auto col-lg-12 add-button detail-icons m-2 p-1">
                      <i class="bi bi-arrow-left-right" (click)="changeProducto(producto.id_producto!)" title="Cambiar producto"></i>
                    </div>
                  </div>
                } @else {
                    <div class="col-auto col-lg-12 add-button detail-icons m-2 p-1">
                      <i class="bi bi-arrow-counterclockwise" (click)="restoreProducto(producto.id_producto!)" title="Restaurar producto eliminado"></i>
                    </div>
                }
              </div>

              <hr class="divisor mt-4 mb-1" />
            </div>
          }

          @if (b_envio_domicilio()) {
            <div class="row p-3 pb-2">
              <div class="col-6 col-lg-8">
                <div class="text-start title-product">Valor del envío</div>
                <div class="text-start description-product">Hasta el domicilio</div>
              </div>

              <div class="col-6 col-lg-4 fw-bold fieldInfo text-end text-truncate">
                <input
                  class="add-number"
                  type="number"
                  [ngModel]="n_precio_envio()"
                  (ngModelChange)="n_precio_envio.set($event); refreshTotal()"
                  name="n_precio_envio"
                  inputmode="decimal"
                  (input)="onPrecioInput($event)"
                  (blur)="formatPrecio()"
                  placeholder="0.00"
                />
              </div>

              <div class="row col-3 col-lg-2 fw-bold fieldInfo text-end text-truncate"></div>
            </div>

            <div class="row p-3 pb-2">
              <div class="col-7 col-lg-8">
                <div class="text-start title-product">Tiempo de envío</div>
                <div class="text-start description-product">Mins. estimados hasta el domicilio</div>
              </div>

              <div class="col-5 col-lg-4 fw-bold fieldInfo text-end text-truncate">
                <input
                  class="add-number"
                  type="number"
                  [ngModel]="n_tiempo_envio()"
                  (ngModelChange)="n_tiempo_envio.set($event)"
                  name="n_tiempo_envio"
                />
              </div>

              <div class="row col-3 col-lg-2 fw-bold fieldInfo text-end text-truncate"></div>
            </div>
          }
        </div>
      }

      <!-- ===================== CAMBIAR VADEMECUM ===================== -->
      @if (panel() === 'editVademecum') {
        <div class="row fade-in pt-2 pb-2 m-2">
          <div class="row align-items-center pe-0">
            <div class="col-10 col-lg-11 text-p p-3 pt-1 pb-1" style="font-weight: bold; font-size: 1em;">
              Cambiar medicamento
            </div>
            <div
              class="col-2 col-lg-1 text-p p-3 pb-1 text-end close-modal-btn pt-1 pe-0"
              style="font-weight: bold; font-size: 1em;"
              (click)="closeModal()"
            >
              <i class="bi bi-x-circle"></i>
            </div>
          </div>
          <hr />

          <div class="col align-items-center pb-5 mb-5">
            <div class="row-cols-12 p-3 pt-0 pb-0 ps-0 pe-0 input-group fade-in search-input-row">
              <div class="col-auto rounded-start" id="search-addon">
                <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
              </div>
              <div class="col rounded">
                <input
                  type="search"
                  [(ngModel)]="searchVademecums"
                  name="searchVademecums"
                  class="form-control search-input shadow-none"
                  placeholder="Busca tu medicamento aquí"
                  aria-label="Search"
                  aria-describedby="search-addon"
                  (keyup)="searchTermVademecums$.next($any($event.target).value)"
                />
              </div>
              <div class="col-auto rounded-end text-end" id="mic-addon">
                <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
              </div>
            </div>

            <div class="row-cols-12 m-2 ps-2 pe-2 w-100">
              <div class="resultSearch">
                @for (vademecum of (vademecumsFiltrados$ | async) ?? []; track vademecum.id) {
                  <a class="hiddenList">
                    <div class="row p-0 pb-2 align-items-center">
                      <div class="col">
                        <div class="row">
                          <div class="col-auto text-title-item pe-0">{{ vademecum.x_nombre }}</div>
                          <div class="col-auto text-title-item pe-0 text-success"><b>${{ vademecum.n_precio }}</b></div>
                        </div>
                        <div class="col-10 text-detail-item">
                          {{ vademecum.nombreLaboratorio }} - {{ vademecum.x_presentacion }}
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="add-button mt-2 me-2" (click)="addVademecumCart(vademecum)">
                          <i class="bi bi-plus align-middle"></i>
                        </div>
                      </div>
                    </div>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <!-- ===================== CAMBIAR PRODUCTO ===================== -->
      @if (panel() === 'editProducto') {
        <div class="row fade-in pt-2 pb-2 m-2">
          <div class="row align-items-center pe-0">
            <div class="col-10 col-lg-11 text-p p-3 pt-1 pb-1" style="font-weight: bold; font-size: 1em;">
              Cambiar producto
            </div>
            <div
              class="col-2 col-lg-1 text-p p-3 pb-1 pt-1 text-end close-modal-btn pe-0"
              style="font-weight: bold; font-size: 1em;"
              (click)="closeModal()"
            >
              <i class="bi bi-x-circle"></i>
            </div>
          </div>
          <hr />

          <div class="col align-items-center pb-5 mb-5">
            <div class="col align-items-center pb-5 mb-5">
              <div class="row-cols-12 p-3 pt-0 pb-0 ps-0 pe-0 input-group fade-in search-input-row">
                <div class="col-auto rounded-start" id="search-addon">
                  <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
                </div>
                <div class="col rounded">
                  <input
                    type="search"
                    [(ngModel)]="searchProductos"
                    name="searchProductos"
                    class="form-control search-input shadow-none"
                    placeholder="Busca tu producto aquí"
                    aria-label="Search"
                    aria-describedby="search-addon"
                    (keyup)="searchTermProductos$.next($any($event.target).value)"
                  />
                </div>
                <div class="col-auto rounded-end text-end" id="mic-addon">
                  <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
                </div>
              </div>

              <div class="row-cols-12 m-2 ps-2 pe-2 w-100">
                <div class="resultSearch">
                  @for (producto of (productosFiltrados$ | async) ?? []; track producto.id) {
                    <a class="hiddenList">
                      <div class="row p-3 pb-0 align-items-center">
                        <div class="col">
                          <div class="row">
                            <div class="col-auto text-title-item pe-0">{{ producto.x_nombre }}</div>
                            <div class="col-auto text-title-item pe-0 text-success"><b>${{ producto.n_precio }}</b></div>
                          </div>
                          <div class="col-10 text-detail-item">SKU: {{ producto.x_sku }}</div>
                        </div>
                        <div class="col-auto">
                          <div class="add-button mt-2 me-2" (click)="addProductoCart(producto)">
                            <i class="bi bi-plus align-middle"></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- ===================== TOTALES ===================== -->
      <div class="row-cols-12 mt-2 mb-2" [ngClass]="isActive()">
        @if (n_ahorro() > 0) {
          <div class="row p-3 pb-0">
            <div class="col col-lg-9 fw-bold text-start">Subtotal</div>
            <div class="col-auto col-lg-3 fw-bold text-end">{{ n_total() | currency:'ARS' }}</div>
          </div>

          <div class="row p-3 pb-0">
            <div class="col col-lg-9 fw-bold text-start">Ahorro</div>
            <div class="col-auto col-lg-3 fw-bold text-end text-success">-{{ n_ahorro() | currency:'ARS' }}</div>
          </div>
        }

        <div class="row p-3 pb-0">
          <div class="col col-lg-9 fw-bold title-total text-start">Total</div>
          @if (n_ahorro() <= 0) {
            <div class="col-auto col-lg-3 fw-bold title-total text-end">{{ n_total() | currency:'ARS' }}</div>
          } @else {
            <div class="col-auto col-lg-3 fw-bold title-total text-end">{{ (n_total() - n_ahorro()) | currency:'ARS' }}</div>
          }
        </div>
      </div>

      <!-- ===================== NOTAS ===================== -->
      <div class="row-cols-12 mt-0" [ngClass]="isActive()">
        <div class="row p-3 pb-0">
          <div class="col col-lg-10 fw-bold titleQuestion text-truncate">
            <b>Notas al cliente</b>
          </div>
        </div>
        <div class="row p-4 pb-0 pt-2">
          <textarea class="add-notes" rows="2" [ngModel]="x_notas()" (ngModelChange)="x_notas.set($event)" name="x_notas"></textarea>
        </div>
      </div>

      <hr class="divisor mt-3 mb-1" />
    </div>

    <div [hidden]="error().length == 0" class="alert alert-danger mt-2" role="alert">
      <small>{{ error() }}</small>
    </div>

    <div class="d-grid mt-4 mb-3 pb-3">
      <button
        type="button"
        class="btn btn-primary btn-lg mt-0"
        (click)="finalizaResponseOrder()"
        [disabled]="loading()"
      >
        {{ loading() ? 'Cargando...' : 'Enviar cotización revisada' }}
      </button>
    </div>
  </div>
}

@if (isFinished()) {
  <div class="container mt-5 fade-in-left">
    <div class="row p-3 mb-3 mt-5 align-items-center">
      <div class="mt-5">
        <div class="row form-switch ps-0 mb-3">
          <div class="col text-center sucess-text mt-5 mb-5">
            <b>¡La solicitud de Compra fue respondida correctamente<br /><span class="bluetext"><strong>al cliente!</strong></span></b>
          </div>
        </div>
      </div>

      <div class="d-grid mt-3 mb-2">
        <button [routerLink]="['/dashboard']" type="button" class="btn btn-primary btn-lg mt-0">Volver</button>
      </div>
    </div>
  </div>
}